import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional, Silent } from "@/__main__/data-model.mjs";
import type { LolRegionSymbol } from "@/game-lol/constants/constants.mjs";
import RegionSymbol from "@/game-lol/utils/symbol-region.mjs";
import gql from "@/util/graphql-query.mjs";

export const League = {
  division: Optional(String),
  freshBlood: Optional(Boolean),
  hotStreak: Optional(Boolean),
  inactive: Optional(Boolean),
  leaguePoints: Optional(Number),
  losses: Optional(Number),
  miniSeries: Optional({
    losses: Number,
    progress: String,
    target: Number,
    wins: Number,
  }),
  queue: Optional({ id: Optional(String), name: Optional(String) }),
  queueId: Optional(String),
  ratedRating: Optional(Number),
  ratedTier: Optional(String),
  tftProfileId: Optional(Number),
  tier: Optional(String),
  veteran: Optional(Boolean),
  wins: Optional(Number),
} satisfies ModelDefinition;

export const model = Silent({
  id: String,
  insertedAt: String,
  probuildPlayerId: String,
  profileIconId: Number,
  puuid: String,
  // FIXME: Remove annotation. With strict-ts this tries to resolve to StringConstructor and fails.
  region: RegionSymbol as (_: unknown) => LolRegionSymbol,
  riotAccount: Silent({
    gameName: String,
    tagLine: String,
    id: String,
    puuid: String,
  }),
  summonerId: String,
  summonerLevel: Number,
  summonerName: String,
  updatedAt: String,
}) satisfies ModelDefinition;

export const gqlModel = gql`{
  ${model}
  ranks(patchId: $patchId, queueId: $queueId) {${League}} 
}`;

const fullModel = Silent({
  id: String,
  insertedAt: String,
  probuildPlayerId: String,
  profileIconId: Number,
  puuid: String,
  // FIXME: Remove annotation. With strict-ts this tries to resolve to StringConstructor and fails.
  region: RegionSymbol as (_: unknown) => LolRegionSymbol,
  riotAccount: Silent({
    gameName: String,
    tagLine: String,
    id: String,
    puuid: String,
  }),
  summonerId: String,
  summonerLevel: Number,
  summonerName: String,
  updatedAt: String,
  ranks: Silent([League]),
}) satisfies ModelDefinition;

const TftPlayerModel = createModel({
  data: { profile: Silent(fullModel) },
}).transform(fullModel, (data) => data.data.profile);

export type TftPlayer = FromModel<typeof TftPlayerModel>;

export default TftPlayerModel;
